export default "/signup/_next/static/chunks/fonts/ProximaNova-Regular-021bc8872db0af60c8e44f087f63e320.otf";